import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { Service } from './services.types'

export const USE_GET_SERVICES_QUERY_KEY = 'useGetServices'

export const getServices = async (signal?: AbortSignal) => {
  const response = await authAPI.get<Service[]>('/shop', { signal })
  return response.data
}

export const useGetServices = () => {
  return useQuery({
    queryFn: ({ signal }) => getServices(signal),
    queryKey: [USE_GET_SERVICES_QUERY_KEY],
  })
}

export const useInvalidateServices = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_SERVICES_QUERY_KEY] })
}
